import {
  IAvailableBenefitHoldingResponse,
  IBenefitsUsageResponse,
  IBenefitUsageDetail,
  ISearchOptions,
  ICustomBenefit
} from '../../../interfaces/benefits';
import { IChangeBusinessData, IChangeBusinessDataResponse } from '../../../interfaces/businessData';
import { IMembersToAddResponse, IMemberToAddsData } from '../../../interfaces/responseInterface';
import { AVAILABLE_BENEFITS_HOLDING_MOCK, BENEFITS_USAGE_MOCK, BENEFIT_USAGE_MOCK } from '../../../mocks/benefits';
import { DEFAULT_CUSTOM_RESPONSE_MOCK } from '../../../mocks/customResponse';
import { CHANGE_HOLDING_DATA_MOCK_RESPONSE, MOCK_COLLABORATORS_TO_ADD } from '../../../mocks/holding';
import { HttpService, HttpServiceServer } from '../../http/httpService';

export class Holding {
  static async getBenefitsUsage(holdingId: number, searchOptions: ISearchOptions): Promise<IBenefitsUsageResponse> {
    const response = await HttpService.get<IBenefitsUsageResponse>(
      `holdings/${holdingId}/benefits`,
      {
        params: {
          startDate: searchOptions.dateRange[0],
          endDate: searchOptions.dateRange[1],
          period: searchOptions.period
        }
      },
      { data: BENEFITS_USAGE_MOCK }
    );
    return response.data;
  }

  static async getBenefitUsage(
    holdingId: number,
    providerId: number,
    benefitId: number,
    searchOptions: ISearchOptions
  ): Promise<IBenefitUsageDetail> {
    const response = await HttpService.get<IBenefitUsageDetail>(
      `holdings/${holdingId}/providers/${providerId}/benefits/${benefitId}`,
      {
        params: {
          startDate: searchOptions.dateRange[0],
          endDate: searchOptions.dateRange[1],
          period: searchOptions.period
        }
      },
      { data: BENEFIT_USAGE_MOCK }
    );
    return response.data;
  }

  static async getAvailableBenefits(holdingId: number): Promise<IAvailableBenefitHoldingResponse[]> {
    const response = await HttpService.get<IAvailableBenefitHoldingResponse[]>(
      `holdings/${holdingId}/providers`,
      {},
      { data: AVAILABLE_BENEFITS_HOLDING_MOCK }
    );
    return response.data;
  }

  static async getCustomBenefit(holdingId: number, benefitId: number): Promise<ICustomBenefit> {
    const response = await HttpService.get<ICustomBenefit>(
      `holdings/${holdingId}/custom/benefits/${benefitId}`,
      {},
      { data: BENEFIT_USAGE_MOCK }
    );
    return response.data;
  }

  static async patchHoldingAttributes(
    holdingId: number,
    holdingData: IChangeBusinessData
  ): Promise<IChangeBusinessDataResponse> {
    const response = await HttpService.patch<IChangeBusinessDataResponse>(
      `holdings/${holdingId}`,
      holdingData,
      {},
      CHANGE_HOLDING_DATA_MOCK_RESPONSE
    );
    return response.data;
  }

  static async getMembersToAdd(holdingId: number, searchValue?: string): Promise<IMembersToAddResponse> {
    const response = await HttpServiceServer.get<IMembersToAddResponse>(
      `holdings/${holdingId}/pending-members`,
      {
        params: {
          searchValue,
          includeDismissed: false
        }
      },
      MOCK_COLLABORATORS_TO_ADD
    );
    return response.data;
  }

  static async assignMembers(holdingId: number, membersData: IMemberToAddsData[]): Promise<void> {
    const body = {
      membersData
    };
    await HttpServiceServer.post(`holdings/${holdingId}/members/assign`, body, {}, DEFAULT_CUSTOM_RESPONSE_MOCK);
  }

  static async dismissPendingMembers(holdingId: number, emails: string[]): Promise<void> {
    const body = {
      emails
    };
    await HttpServiceServer.put(
      `holdings/${holdingId}/pending-members/dismiss`,
      body,
      {},
      DEFAULT_CUSTOM_RESPONSE_MOCK
    );
  }
}

export default Holding;
